import { styled } from 'styled-components'

const EDGE_SPACING_PX = 20
const VERTICAL_SPACING_PX = 12

export const Carousel = styled.div`
  overflow: hidden;
`

// Embla reads the first slide's offset and the last slide's margin as the
// carousel's edge gaps, so the outer spacing lives on the track and slides.
// The vertical padding is inside the clipping viewport to keep the cards' shadow.
export const Track = styled.div`
  display: flex;
  padding: ${VERTICAL_SPACING_PX}px ${EDGE_SPACING_PX}px;
  touch-action: pan-y pinch-zoom;
`

export const Slide = styled.div`
  flex: 0 0 89%;
  min-width: 0;
  margin-right: 10px;

  &:last-child {
    margin-right: ${EDGE_SPACING_PX}px;
  }

  &:only-child {
    flex-basis: 100%;
  }
`

export const Dots = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-bottom: ${VERTICAL_SPACING_PX}px;
`

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.black};
  opacity: 0.2;
  cursor: pointer;
  transition: opacity 0.3s;

  &[aria-current='true'] {
    opacity: 1;
  }
`
